import { upsellElements } from './upsellElements';

export const checkInventoryStatus = (upsellProductId: string) => {
  const { upsellWrapper } = upsellElements();

  const productFormArray = upsellWrapper.querySelectorAll(
    `[data-node-type="commerce-add-to-cart-form"][data-commerce-product-id="${upsellProductId}"]`
  );

  const productForm = productFormArray[0];

  const productWrapper = productForm?.closest(
    '[role="listitem"]'
  ) as HTMLElement;

  const upsellInventoryDivArray = (productWrapper?.getElementsByClassName(
    'w-commerce-commerceaddtocartoutofstock'
  ) as unknown) as [HTMLElement] | undefined;

  let upsellInventoryDiv;
  let upsellInventoryStatus: 'AVAILABLE' | 'NOT_AVAILABLE' = 'NOT_AVAILABLE';

  if (upsellInventoryDivArray && upsellInventoryDivArray.length === 1) {
    upsellInventoryDiv = upsellInventoryDivArray[0];

    upsellInventoryStatus =
      upsellInventoryDiv.style.display === '' ? 'NOT_AVAILABLE' : 'AVAILABLE';
  }

  return { upsellInventoryStatus };
};
